export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">联系与投稿</h2>
          <p className="text-sm md:text-base text-foreground-600">有任何问题、建议或合作意向？欢迎通过以下方式与我们取得联系。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 text-center">
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-xl text-primary-600"></i>
            </div>
            <h3 className="text-sm font-bold font-heading text-foreground-950 mb-2">商务合作</h3>
            <p className="text-xs text-foreground-600 mb-3">广告投放 · 版权合作 · 品牌联名</p>
            <span className="text-sm text-primary-600 font-medium">business@dashixiong.tv</span>
          </div>

          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 text-center">
            <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-chat-3-line text-xl text-accent-600"></i>
            </div>
            <h3 className="text-sm font-bold font-heading text-foreground-950 mb-2">用户反馈</h3>
            <p className="text-xs text-foreground-600 mb-3">意见反馈 · 功能建议 · 问题报告</p>
            <span className="text-sm text-primary-600 font-medium">feedback@dashixiong.tv</span>
          </div>

          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 text-center">
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-send-plane-line text-xl text-primary-600"></i>
            </div>
            <h3 className="text-sm font-bold font-heading text-foreground-950 mb-2">内容投稿</h3>
            <p className="text-xs text-foreground-600 mb-3">影评投稿 · 片单推荐 · 影视资讯</p>
            <span className="text-sm text-primary-600 font-medium">contribute@dashixiong.tv</span>
          </div>
        </div>
      </div>
    </section>
  );
}